<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="fmh2"><a id="Contents"></a><a id="page_1"><b>CONTENTS</b></a></p><a id="page_1">
</a></div><a id="page_1">
</a><p class="toc"><a id="page_1"></a><a href="#/xhtml/glossary">Glossary and Abbreviations</a></p>
<p class="toc1a"><a href="#/xhtml/intro">Introduction</a></p>
<p class="toc1"><span href="#/xhtml/ch01" title="Link target outside of Sample">Chapter 1: In Support of the Civil Authority</span></p>
<p class="toc1"><span href="#/xhtml/ch02" title="Link target outside of Sample">Chapter 2: The Land Freedom Armies</span></p>
<p class="toc1"><span href="#/xhtml/ch03" title="Link target outside of Sample">Chapter 3: Paradise Lost</span></p>
<p class="toc1"><span href="#/xhtml/ch04" title="Link target outside of Sample">Chapter 4: The Blunt Instrument</span></p>
<p class="toc1"><span href="#/xhtml/ch05" title="Link target outside of Sample">Chapter 5: The Long Goodbye</span></p>
<p class="toc1"><span href="#/xhtml/ch06" title="Link target outside of Sample">Chapter 6: Special Forces</span></p>
<p class="toc1"><span href="#/xhtml/ch07" title="Link target outside of Sample">Chapter 7: The Hunt for Dedan Kimathi</span></p>
<p class="toc1"><span href="#/xhtml/ch08" title="Link target outside of Sample">Chapter 8: Rehabilitation</span></p>
<p class="toc1"><span href="#/xhtml/ch09" title="Link target outside of Sample">Chapter 9: Legacy of Mau Mau</span></p>
<p class="toc2"><span href="#/xhtml/appendix" title="Link target outside of Sample">Appendix: British Units involved in the Kenyan Emergency</span></p>
<p class="toc2a"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="fmimg"><img alt="Image" src="images/fig_001.jpg" style="max-width:100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?49a5e9dd